export const energyRatingChartConfig = [
    {
        range: [92, 100],
        label: 'A',
        color: '#007E2E',
        variant: 'white',
    },
    {
        range: [81, 91],
        label: 'B',
        color: '#2C9F29',
        variant: 'white',
    },
    {
        range: [69, 80],
        label: 'C',
        color: '#A1D20E',
        variant: 'black',
    },
    {
        range: [55, 68],
        label: 'D',
        color: '#F8F400',
        variant: 'black',
    },
    {
        range: [39, 54],
        label: 'E',
        color: '#F1C300',
        variant: 'black',
    },
    {
        range: [21, 38],
        label: 'F',
        color: '#E77C17',
        variant: 'black',
    },
    {
        range: [1, 20],
        label: 'G',
        color: '#C30909',
        variant: 'white',
    },
];
export const environmentImpactChartConfig = [
    {
        range: [92, 100],
        label: 'A',
        color: '#CDE2F5',
        variant: 'black',
    },
    {
        range: [81, 91],
        label: 'B',
        color: '#97C0E6',
        variant: 'black',
    },
    {
        range: [69, 80],
        label: 'C',
        color: '#73A2D6',
        variant: 'black',
    },
    {
        range: [55, 68],
        label: 'D',
        color: '#4E84C4',
        variant: 'white',
    },
    {
        range: [39, 54],
        label: 'E',
        color: '#A5A6A9',
        variant: 'black',
    },
    {
        range: [21, 38],
        label: 'F',
        color: '#919194',
        variant: 'black',
    },
    {
        range: [1, 20],
        label: 'G',
        color: '#707070',
        variant: 'white',
    },
];
